import {LuPencil,FiAirplay,FaRegHospital, LiaBookReaderSolid, LuBarChart2, LiaFileInvoiceDollarSolid,LuCircleDollarSign, LuBarChart3 } from '../assets/icons/vander'

export const jobCategory = [
    {
        icon:LuPencil,
        title:'Design & Art',
        opening:'7 Opening'
    },
    {
        icon:FiAirplay,
        title:'IT Engineer',
        opening:'1 Opening'
    },
    {
        icon:FaRegHospital,
        title:'Health Care',
        opening:'4 Opening'
    },
    {
        icon:LiaBookReaderSolid,
        title:'Teaching',
        opening:'2 Opening'
    },
    {
        icon:LuBarChart2,
        title:'Management',
        opening:'8 Opening'
    },
    {
        icon:LiaFileInvoiceDollarSolid,
        title:'Marketing',
        opening:'5 Opening'
    },
    {
        icon:LuCircleDollarSign,
        title:'Sales',
        opening:'2 Opening'
    },
    {
        icon:LuBarChart3,
        title:'Banking',
        opening:'6 Opening'
    },
]

export const jobData = [
    {
        id:1,
        title:'Web Designer',
        jobType:'Full time',
        name:'leaping pvt. ltd.',
        country:'India'
    },
    {
        id:2,
        title:'Front-end Developer',
        jobType:'Remote',
        name:'Hostick pvt. ltd.',
        country:'Australia'
    },
    {
        id:3,
        title:'Web Developer',
        jobType:'Contract',
        name:'Landflow pvt. ltd.',
        country:'USA'
    },
    {
        id:4,
        title:'Back-end Developer',
        jobType:'WFH',
        name:'leaping pvt. ltd.',
        country:'China'
    },
    {
        id:5,
        title:'UX / UI Designer',
        jobType:'Full time',
        name:'Porfo pvt. ltd.',
        country:'Canada'
    },
    {
        id:6,
        title:'Tester',
        jobType:'Remote',
        name:'Bootgen pvt. ltd.',
        country:'India'
    },
    {
        id:7,
        title:'Web Designer',
        jobType:'Full time',
        name:'leaping pvt. ltd.',
        country:'India'
    },
    {
        id:8,
        title:'Front-end Developer',
        jobType:'Remote',
        name:'Hostick pvt. ltd.',
        country:'Australia'
    },
    {
        id:9,
        title:'Web Developer',
        jobType:'Contract',
        name:'Landflow pvt. ltd.',
        country:'USA'
    },
    {
        id:10,
        title:'Back-end Developer',
        jobType:'WFH',
        name:'leaping pvt. ltd.',
        country:'China'
    }
]

export const jobDuties = [
'Participate in requirements analysis',
'Write clean, scalable code using C# and .NET frameworks',
'Test and deploy applications and systems',
'Revise, update, refactor and debug code',
'Improve existing software',
'Develop documentation throughout the software development life cycle (SDLC)',
'Serve as an expert on applications and provide technical support',
]

export const jobSkill = [
    'Proven experience as a .NET Developer or Application Developer',
    'good understanding of SQL and Relational Databases, specifically Microsoft SQL Server.',
    'Experience designing, developing and creating RESTful web services and APIs',
    'Basic know how of Agile process and practices',
    'Good understanding of object-oriented programming.',
    'Good understanding of concurrent programming.',
    'Sound knowledge of application architecture and design.',
    'Excellent problem solving and analytical skills',
]